import { SystemThemeAtom } from '@capsicum/common';
import { useSetAtom } from 'jotai';
import { useEffect, useLayoutEffect } from 'react';

export const useSystemTheme = (): void => {
	const setSystemThemeAtom = useSetAtom(SystemThemeAtom);

	useLayoutEffect(() => {
		setSystemThemeAtom(window?.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
	}, []);

	useEffect(() => {
		if (typeof window === 'undefined') {
			return;
		}

		const listener = (e: MediaQueryListEvent) => {
			setSystemThemeAtom(e.matches ? 'dark' : 'light');
		};

		const darkThemeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

		darkThemeMediaQuery.addEventListener('change', listener);

		return () => {
			darkThemeMediaQuery.removeEventListener('change', listener);
		};
	}, [setSystemThemeAtom]);
};
